import React from 'react';
import AutoLayout from './AutoLayout';
/**
 * Wrap children in an AutoLayout component.
 *
 * @param {autolayout} {boolean}  Activate/deactivate the autolayouting mechanism.
 */
const AutoLayoutWrapper = ({ autolayout = true, children, }) => {
    if (autolayout === true) {
        return React.createElement(AutoLayout, null, children);
    }
    else if (autolayout) {
        return React.createElement(AutoLayout, { matrix: autolayout }, children);
    }
    else {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return React.createElement(React.Fragment, null, children);
    }
};
export default AutoLayoutWrapper;
//# sourceMappingURL=AutoLayoutWrapper.js.map